import { useApplicationStore } from "@/stores/Application";
import { computed, nextTick, type ComputedRef } from "vue";
import { storeToRefs } from "pinia";

interface ExposeInterface {
    setIsHaveFocusedElement: () => void;
    focusElementLine: () => void;
    focusToHeader: () => void;
}

export const useFocus = () => {
    const ApplicationStore = useApplicationStore();
    const {
        getCurrentSelectedIdProgram,
    } = storeToRefs(ApplicationStore);
    const { 
        setIsHaveFocusedElement: setIsHaveFocusedElementToStore,
        hideHeader,
        deleteSelectedIdProgram
    } = ApplicationStore;


    const selectedIdProgram = computed((): string | null => {
        let currentSelectedIdProgram = getCurrentSelectedIdProgram.value;

        if (currentSelectedIdProgram !== null) {
            const [id, index] = currentSelectedIdProgram.split('_');
            const htmlElement = document.getElementById(currentSelectedIdProgram);
            if ((index === 'show-all' || index === 'plus') && (htmlElement === null || htmlElement === undefined)) {
                // If the shelf has been reduced in size and the buttons 'show-all' and 'plus' have been removed, then we use the shelf ID
                //TODO: Investigate: Maybe we don't need it.
                currentSelectedIdProgram = id;
            }
        }

        return currentSelectedIdProgram;
    });
    const selectedElement: ComputedRef<HTMLElement | null> = computed(() => {
        if (selectedIdProgram.value) {
            const htmlElement = document.getElementById(selectedIdProgram.value);
            if (htmlElement instanceof HTMLElement) {
                return htmlElement;
            }
        }
        return null;
    });

    const setIsHaveFocusedElement = (): void => {
        if (selectedIdProgram.value) {
            const htmlElement = document.getElementById(selectedIdProgram.value);
            if (htmlElement instanceof HTMLElement) {
                setIsHaveFocusedElementToStore(true);
            }
        }
    };

    const focusElementLine = (): void => {
        const element = selectedElement.value;
        nextTick(() => {
            if (element) {
                hideHeader();
                element.focus();
                deleteSelectedIdProgram();
            }
            setIsHaveFocusedElementToStore(false);
        });
    };
    const focusToHeader = (): void => {
        const isHeader = document.activeElement ? document.activeElement.getAttribute('data-parent') : null;
        if (isHeader) {
            return;
        }
        document.getElementById("header-menu")?.focus();
    }

    return<ExposeInterface>{
        setIsHaveFocusedElement,
        focusElementLine,
        focusToHeader
    };
}